import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Canny vs the Alternatives | Canny Competitors';
const Description =
  "See how Canny stacks up against its top competitors! Our deep dives look at each Canny alternative's features, integrations, pricing, and more.";
const Image = 'https://canny.io/images/canny-social.png';

export default class CompareLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/compare' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
